import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';

export class BaselineScenario extends BasicScenario {
manageValues: boolean | null;
}

